var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/* eslint-disable no-underscore-dangle */
import { Component, Mixins } from 'vue-property-decorator';
import { debounce } from "lodash-es";
import devToolMixin from '../../../util/devToolMixin';
import { SearchInPageLet } from "../../../../../../lib/utils/searchPagelet/PageletSearch";
// eslint-disable-next-line @typescript-eslint/no-var-requires
import captureIcon from "../../../../../../lib/assets/captureIcon.svg";
let OptionBar = class OptionBar extends Mixins(devToolMixin) {
  get debouncedInput() {
    return debounce(value => {
      this.searchInput = value;
    }, 500).bind(this);
  }
  mounted() {
    this.pageletSearch = new SearchInPageLet(this.ultPagelet, this.uc, {
      filterSearchPath: ['comps']
    });
    this.$watch(() => [this.searchInput, this.ultPagelet], () => {
      var _this$pageletSearch;
      this.pageletSearch.updatePageLet(this.ultPagelet);
      this.pageletSearch.searchInput = this.searchInput;
      const resWithoutEmpty = (_this$pageletSearch = this.pageletSearch) === null || _this$pageletSearch === void 0 ? void 0 : _this$pageletSearch.getPageLetSearchWithGeneratorNotEmpty();
      this.searchCandidates = resWithoutEmpty.comps.map(obj => obj.object);
    }, {
      deep: true
    });
  }
  beforeDestroy() {
    this.bus.options.capturing = false;
  }
  startCapture() {
    this.bus.options.capturing = true;
  }
  render() {
    const h = arguments[0];
    return h("div", {
      "class": "ucd-devTool-layout-search"
    }, [h("div", {
      "class": "input"
    }, [h("a-input", {
      "on": {
        "change": e => this.debouncedInput(e.target.value)
      },
      "attrs": {
        "placeholder": "搜索组件",
        "allowClear": true,
        "value": this.searchInput
      }
    }, [h("a-icon", {
      "slot": "prefix",
      "attrs": {
        "type": "search"
      }
    }), h("span", {
      "slot": "addonAfter"
    }, [h("a-tooltip", {
      "attrs": {
        "getPopupContainer": () => {
          var _this$windowRef;
          return ((_this$windowRef = this.windowRef) === null || _this$windowRef === void 0 ? void 0 : _this$windowRef.document.body) || window.document.body;
        }
      }
    }, [h("span", {
      "slot": "title"
    }, ["\u6355\u83B7\u7EC4\u4EF6 "]), h("img", {
      "attrs": {
        "src": captureIcon
      },
      "class": `capture_icon  ${this.bus.options.capturing ? 'activated' : ''} ${this.isDesignMode ? 'disabled' : ''}`,
      "on": {
        "click": this.startCapture
      }
    })]), !!this.searchInput ? h("span", {
      "class": "actions"
    }, [h("a-button", {
      "attrs": {
        "ghost": true,
        "icon": "arrow-up"
      },
      "on": {
        "click": this.selectPrevCandidate
      },
      "class": "action-btn"
    }), h("a-button", {
      "attrs": {
        "ghost": true,
        "icon": "arrow-down"
      },
      "on": {
        "click": this.selectNextCandidate
      },
      "class": "action-btn"
    })]) : null])])]), h("div", {
      "class": "checkboxes"
    }, [h("a-checkbox", {
      "attrs": {
        "checked": this.bus.options.showCnName
      },
      "on": {
        "change": e => this.$set(this.bus.options, 'showCnName', e.target.checked)
      }
    }, ["\u663E\u793A\u4E2D\u6587\u540D"]), h("a-checkbox", {
      "attrs": {
        "checked": this.bus.options.showActions
      },
      "on": {
        "change": e => this.$set(this.bus.options, 'showActions', e.target.checked)
      }
    }, ["\u663E\u793A\u64CD\u4F5C\u680F"])])]);
  }
};
OptionBar = __decorate([Component({
  name: 'option-bar'
})], OptionBar);
export default OptionBar;
//# sourceMappingURL=OptionBar.js.map
